import { Component, EventEmitter, Input, input, Output, ViewChild } from '@angular/core'
import { RouterModule } from '@angular/router'
import { BranchNavItem, SideNavDisplayMode, SideNavGroup, SideNavItem } from '../../navigation/side-nav-item'
import { LogoSize, LogoTheme } from '../../types/logo'
import { FtrLogoComponent } from '../ftr-logo/ftr-logo.component'
import { SideNavShellComponent } from '../side-nav-shell/side-nav-shell.component'
import {
  USER_AND_ORG_MENU_ITEMS,
  UserAndOrgDropdownComponent,
} from '../user-and-org-dropdown/user-and-org-dropdown.component'

@Component({
  selector: 'ftr-public-side-nav-display',
  templateUrl: './public-side-nav-display.component.html',
  styleUrls: ['./public-side-nav-display.component.css'],
  imports: [SideNavShellComponent, FtrLogoComponent, RouterModule, UserAndOrgDropdownComponent],
})
export class PublicSideNavDisplayComponent {
  @Input() displayMode: SideNavDisplayMode = 'DEFAULT'
  @Input() expanded: boolean = true
  @Input() isLoading: boolean = false
  @Input() isOpened: boolean
  @Output() sideBarToggled = new EventEmitter<void>()
  @Output() expandedToggled = new EventEmitter<void>()

  navGroups = input([] as SideNavGroup[])
  footerItems = input([] as SideNavItem[])
  @ViewChild(SideNavShellComponent) private shell: SideNavShellComponent

  protected readonly logoSize = LogoSize
  protected readonly logoTheme = LogoTheme

  private readonly userMenuNavItems: SideNavItem[] = USER_AND_ORG_MENU_ITEMS.map(item => ({
    type: 'LINK',
    ...item,
  }))

  onUserDropdownOpened(): void {
    this.shell.openBranchNav({ type: 'BRANCH', title: 'Account', children: this.userMenuNavItems } as BranchNavItem)
  }
}
